export default { // 该需求运行在评估师app > 我的工单 > 更多 > 补充信息
  tabs: [
    {
      name: 'AddCarInfo',
      path: '/addCarInfo',
      component: () => import('./src/AddCarInfo.vue'),
      meta: {
        title: '车辆补充信息',
        isMenu: true
      }
    }
  ]
}
